(function () {
  'use strict';

  function initImageBlockV1(root) {
    if (!root || root.getAttribute('data-ml353-bound') === '1') return;
    root.setAttribute('data-ml353-bound', '1');

    var panels = Array.from(root.querySelectorAll('[data-ibv1-panel]'));
    var pills = Array.from(root.querySelectorAll('[data-ibv1-pill]'));
    var prevBtn = root.querySelector('.ibv1-prev');
    var nextBtn = root.querySelector('.ibv1-next');
    var count = panels.length;
    if (!count) return;

    var current = 0;
    panels.forEach(function (panel, i) {
      if (panel.classList.contains('is-active')) current = i;
    });

    function showSlide(index) {
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      current = index;
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
      pills.forEach(function (pill, i) {
        var on = i === index;
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () {
        showSlide(i);
      });
    });
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showSlide(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showSlide(current + 1);
      });
    }

    showSlide(current);
  }

  function initAllImageBlockV1() {
    document.querySelectorAll('[data-ibv1]').forEach(initImageBlockV1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllImageBlockV1);
  } else {
    initAllImageBlockV1();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (event.target.querySelector('[data-ibv1]')) initAllImageBlockV1();
  });
})();
